import imageCompression from "browser-image-compression";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import { ImageCompressConfig } from "../../../constants/ImageCompressConfig";
import { CheckIsNull } from "../../../utils/CommonHelper";
import { ErrorContainer } from "../../common/control/InputField";

export const WithdrawApproveForm = ({
  formikRef,
  saveValues,
  clearFileInputRef,
}) => {
  const intl = useIntl();
  const [receipt, setReceipt] = useState();
  const [receiptTouched, setReceiptTouched] = useState(false);

  const handleFileChange = (event) => {
    const handleFile = (file, fileName) => {
      const newFile = new File([file], fileName, {
        type: file.type,
      });
      setReceipt(newFile);
    };

    const fileName = event.currentTarget.files[0].name;
    imageCompression(event.currentTarget.files[0], ImageCompressConfig)
      .then((res) => handleFile(res, fileName))
      .catch(() => handleFile(event.currentTarget.files[0], fileName));
  };

  return (
    <Formik
      innerRef={formikRef}
      enableReinitialize={true}
      initialValues={{ receipt: "" }}
      onSubmit={(values, formikHelpers) => {
        if (!CheckIsNull(receipt)) {
          const queryParams = {
            receipt: receipt,
          };
          saveValues(queryParams);
        } else {
          setReceiptTouched(true);
        }
      }}
    >
      {({ values, setFieldValue, touched, errors, setFieldError }) => (
        <Form>
          <div className="p-3 custom-border-bottom">
            <input
              name="image_chooser"
              type="file"
              className="form-control text-font2"
              placeholder={intl.formatMessage({ id: "receipt" })}
              autoComplete="off"
              accept="image/*"
              onChange={handleFileChange}
              onClick={() => setReceiptTouched(true)}
              ref={clearFileInputRef}
            />
            <ErrorContainer
              isShow={receiptTouched && CheckIsNull(receipt)}
              errorMsg={intl.formatMessage({ id: "receiptRequired" })}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};
